import React, { useState, type ComponentProps } from "react"
import Image from "next/image"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"
import BlogArrow from "../_Icon/BlogArrow"

type Props = {
  img: ComponentProps<typeof Image>["src"]
  title: string
  desc: string
  link: string
  linkText?: string
  date?: number | string
  linkType?: boolean
  t: Function
}

export default function MediumArticleCard({
  img,
  title,
  desc,
  link,
  linkText,
  date,
  linkType,
  t
}: Props) {
  const [Hover, setHover] = useState(false)

  return (
    <CardWrapper
      className="cardWrapper"
      onMouseEnter={() => {
        setHover(true)
      }}
      onMouseLeave={() => {
        setHover(false)
      }}
    >
      <a href={link} target={linkType ? "_self" : "_blank"} rel="noreferrer">
        <div className="imgWrapper">
          <Image
            className="img"
            alt=""
            src={img}
            fill
            sizes="100vw"
            style={{
              objectFit: "cover"
            }}
          />
        </div>
        <TextWrapper className="textWrapper">
          <CardTitle className="cardT ellipsis2">{title}</CardTitle>
          <CardContent className="cardC ellipsis2">{desc}</CardContent>
          <CardLink className="cardL">
            <CardLinkContent>
              <div className="cardT">
                {linkText ? linkText : t("button.cta-read-more")}
              </div>
              {date && <span>{date}</span>}
            </CardLinkContent>
            <BlogArrow className={Hover === true ? "hover" : ""} />
          </CardLink>
        </TextWrapper>
      </a>
    </CardWrapper>
  )
}

const CardWrapper = styled.div`
  transition: 0.3s;
  width: 100%;

  &:hover {
    .cardT {
      color: ${themeGet("colors.primary")};
    }
    p {
      color: ${themeGet("colors.title")};
    }
    h6 {
      // transform: translateX(-10%);
      &:after {
        opacity: 1;
        width: 10%;
      }
      &:before {
        width: 0;
      }
    }
    img {
      transform: scale(1.05);
      opacity: 0.8;
    }
    .textWrapper {
      .cardL {
        justify-content: space-between;
        color: $colorsprimary !important;
        align-items: center;

        span {
          opacity: 1;
        }
      }
    }
  }

  .imgWrapper {
    background-color: #ccc;
    width: 100%;
    padding-bottom: 50%;
    overflow: hidden;
    background-color: #001f58;
    border-radius: 15px;
    position: relative;

    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: 0.5s ease;

      &.asset {
        object-fit: contain;
      }
    }

    @media (max-width: 1024px) {
      height: 200px;
    }
  }
`

const CardTitle = styled.h4`
  font-weight: 700;
  margin-bottom: 10px;
  transition: 0.3s ease;
`
const CardContent = styled.p`
  transition: 0.3s ease;
`
const TextWrapper = styled.div`
  padding: 2rem;
  padding-right: 0;

  padding: 30px 0px 30px 0px !important;

  .cardT {
    margin-top: 0;
    // height: 50px;
  }

  .cardC {
    font-size: 1rem;
    line-height: 1.5rem;
    margin-top: 0px;
    font-weight: normal;
  }

  .cardD {
    font-size: 1rem;
    color: #ccc;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  @media (max-width: 1024px) {
    padding: 2rem 0;
  }
  @media (max-width: 768px) {
    .cardL {
      justify-content: space-between;
      color: $colorsprimary !important;

      span {
        opacity: 1;
      }
    }
  }
  @media (max-width: 600px) {
    cardL {
      font-size: 1rem;
    }
    span {
      opacity: 1;
    }
  }
`

const CardLink = styled.h6`
  width: 100%;
  color: ${themeGet("colors.primary")};
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: 0.3s ease;
  color: #ccc;

  span {
    font-weight: 300;
    opacity: 0;
    transition: 0.3s;
    color: rgba(255, 255, 255, 0.732);
  }
`
const CardLinkContent = styled.div`
  display: flex;
  gap: var(--textGap);
`
